import { render } from "./NetworkWidget.vue?vue&type=template&id=975f6036&scoped=true"
import script from "./NetworkWidget.vue?vue&type=script&lang=js"
export * from "./NetworkWidget.vue?vue&type=script&lang=js"

import "./NetworkWidget.vue?vue&type=style&index=0&id=975f6036&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975f6036"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QIcon,QTabs,QTab,QTabPanels,QTabPanel});
